import { Flex, Box, Heading } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import { ContentLoader } from 'toolkit/components/loaders/ContentLoader';
import ContractVerificationForm from 'ui/contractVerification/ContractVerificationForm';
import useFormConfigQuery from 'ui/contractVerification/useFormConfigQuery';
import DataFetchAlert from 'ui/shared/DataFetchAlert';
import PageTitle from 'ui/shared/Page/PageTitle';
import SearchBar from 'ui/snippets/searchBar/SearchBarDesktop';
import SearchBarMobile from 'ui/snippets/searchBar/SearchBarMobile';

const TEXT_COLOR_DEFAULT = 'white';

const ContractVerification = () => {
  const configQuery = useFormConfigQuery(true);

  const textColor = {
    _light:
      config.UI.homepage.heroBanner?.text_color?.[0] ||
      TEXT_COLOR_DEFAULT,
    _dark:
      config.UI.homepage.heroBanner?.text_color?.[1] ||
      config.UI.homepage.heroBanner?.text_color?.[0] ||
      TEXT_COLOR_DEFAULT,
  };

  const content = (() => {
    if (configQuery.isError) {
      return <DataFetchAlert/>;
    }

    if (configQuery.isPending) {
      return <ContentLoader/>;
    }

    return (
      <ContractVerificationForm config={ configQuery.data }/>
    );
  })();

  return (
    <>
      <Flex
        w="100%"
        background={{ _light: 'radial-gradient(103.03% 103.03% at 0% 0%, rgba(183, 148, 244, 0.8) 0%, rgba(0, 163, 196, 0.8) 100%), var(--chakra-colors-blue-400)', _dark: 'radial-gradient(103.03% 103.03% at 0% 0%, rgba(183, 148, 244, 0.8) 0%, rgba(0, 163, 196, 0.8) 100%), var(--chakra-colors-blue-400)' }}
        borderRadius="md"
        p={{ base: 4, lg: 8 }}
        mb={ 6 }
      >
        <Box flexGrow={ 1 }>
          <Flex mb={{ base: 2, lg: 3 }} justifyContent="space-between" alignItems="center" columnGap={ 2 } flexDirection="column" alignItems="flex-start">
            <Heading
              as="h1"
              fontSize={{ base: '18px', lg: '30px' }}
              lineHeight={{ base: '24px', lg: '36px' }}
              fontWeight={{ base: 500, lg: 700 }}
              color={ textColor }
            >
              PKRD Blockchain Contract Verification
            </Heading>
            <Box fontSize={{ base: 'xs', lg: 'sm' }} color={ textColor }>
              Public Key Reserve Dollar (PKRD)
            </Box>
          </Flex>
          <Box display={{ base: 'flex', lg: 'none' }}>
            <SearchBarMobile isHeroBanner/>
          </Box>
          <Box display={{ base: 'none', lg: 'flex' }}>
            <SearchBar isHeroBanner/>
          </Box>
        </Box>
      </Flex>
      { content }
    </>
  );
};

export default ContractVerification;
